import React from 'react';

// components
import Input from '../../components/general/Input';

import './index.css';

const Profile = props => {
  return (
    <div class="relative bg-yellow bg-opacity-15">
      <div class="relative px-4 sm:px-6 lg:px-8">
        <div class="pt-8 pb-16">
          <h2 class="pt-6 text-4xl font-bold max-w-screen-md mx-auto text-center">
            Complete Your Profile
          </h2>
          <p class="pt-6 font-medium max-w-screen-md mx-auto text-center">
            You’re almost there! You know all about us but this is where we get to know you. We’ll
            need some information to set you up.
          </p>
          <div class="pt-8 max-w-5xl mx-auto ">
            {props.profileError && (
              <p style={{ color: 'red', fontSize: 24 }}>{props.profileError}</p>
            )}
            {props.loaders.completeEnrollment && (
              <div class="loader">
                <div class="loader__element"></div>
              </div>
            )}
            <form
              onSubmit={e => e.preventDefault()}
              class="mt-9 grid grid-cols-1 gap-y-6 sm:grid-cols-4 sm:gap-x-8"
            >
              <div class="sm:col-span-2">
                <div for="first_name" class="block text-sm font-bold leading-5 text-gray-700">
                  Full name
                </div>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <Input
                    autofocus={true}
                    onChange={e => props.handleChange('fullName', e.target.value)}
                    placeholder="John Doe"
                    className="email py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    value={props.fullName}
                    error={props.errors.fullName}
                    marginBottom={true}
                  />
                </div>
              </div>

              <div class="sm:col-span-2">
                <div for="email" class="block text-sm font-bold leading-5 text-gray-700">
                  *Email <div class="inline text-darkYellow"> </div>
                </div>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <Input
                    onChange={e => props.handleChange('email', e.target.value)}
                    placeholder="JohnDoe@example.com"
                    className="email py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    value={props.email}
                    error={props.errors.email}
                    marginBottom={true}
                  />
                </div>
              </div>
              <div class="opacity-50 sm:col-span-2">
                <div for="service-address" class="block text-sm font-bold leading-5 text-gray-700">
                  *Service Address
                </div>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <Input
                    placeholder={props.distributionPoint.address1}
                    id="service-address*"
                    className="py-4 bg-yellow form-input font-medium placeholder-white block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    disabled
                  />
                </div>
              </div>
              <div class="opacity-50">
                <div for="city" class="block text-sm font-bold leading-5 text-gray-700">
                  City
                </div>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <Input
                    placeholder={props.distributionPoint.city}
                    id="city"
                    className="py-4 bg-yellow form-input font-medium placeholder-white block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    disabled
                  />
                </div>
              </div>
              <div class="opacity-50">
                <div for="zip" class="block text-sm font-bold leading-5 text-gray-700">
                  Zip
                </div>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <Input
                    id="zip"
                    placeholder={props.distributionPoint.zipCode}
                    type="number"
                    className="py-4 bg-yellow form-input font-medium placeholder-white block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    disabled
                  />
                </div>
              </div>
              <div class="sm:col-span-2">
                <div for="company" class="block text-sm font-bold leading-5 text-gray-700">
                  *Password <div class="inline text-darkYellow">(Must be 6-8 Characters)</div>
                </div>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <Input
                    onChange={e => props.handleChange('password', e.target.value)}
                    id="company"
                    placeholder="********"
                    type="password"
                    className="py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    value={props.placeholder}
                    error={props.errors.password}
                    marginBottom={true}
                  />
                </div>
              </div>
              <div class="sm:col-span-2">
                <div for="company" class="block text-sm font-bold leading-5 text-gray-700">
                  *Confirm Password{' '}
                  <div class="inline text-darkYellow">(Must be 6-8 Characters)</div>
                </div>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <Input
                    onChange={e => props.handleChange('password2', e.target.value)}
                    id="company"
                    placeholder="********"
                    type="password"
                    className="py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    value={props.placeholder}
                    error={props.errors.password2}
                    marginBottom={true}
                  />
                </div>
              </div>
              <div class="sm:col-span-2">
                <div for="zip" class="block text-sm font-bold leading-5 text-gray-700">
                  Phone Number
                </div>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <Input
                    onChange={e => props.handleChange('phoneNumber', e.target.value)}
                    placeholder="555123456"
                    type="number"
                    value={props.phoneNumber}
                    className="py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    marginBottom={true}
                    error={props.errors.phoneNumber}
                  />
                </div>
              </div>
              <div class="sm:col-span-2">
                <div for="zip" class="block text-sm font-bold leading-5 text-gray-700">
                  Switch or move-in date
                </div>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <Input
                    placeholder={new Date()}
                    onChange={e => props.handleChange('moveInDate', e.target.value)}
                    type="date"
                    value={props.moveInDate}
                    className="py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    marginBottom={true}
                    error={props.errors.moveInDate}
                  />
                </div>
              </div>
              <div class="">
                <span class="rounded-md">
                  <button
                    onClick={props.createAccount}
                    class="bg-gradient-to-r from-red-500 to-yellow px-28 text-xl relative py-6 leading-5 font-bold rounded-md text-white hover:from-yellow hover:to-red-500 focus:outline-none focus:shadow-outline-black focus:border-black-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                  >
                    Next
                  </button>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
